export default "__VITE_ASSET__B8mIV2l7__";